import React from 'react'
import styled, { ThemedStyledProps, withTheme } from 'styled-components'
import ReactTooltipBase, { TooltipProps } from 'react-tooltip'
import { Theme } from 'styles/theme'

const ReactTooltip = styled(ReactTooltipBase)`
  && {
    background-color: ${({ theme }) => theme.colors.backgroundSecondary};
    color: ${({ theme }) => theme.colors.white};
    font-size: 13px;
    font-weight: 600;
    line-height: 17px;
    max-width: 30vw;
    opacity: 1;
    white-space: normal;
  }
`

function Tooltip({ theme, ...props }: ThemedStyledProps<TooltipProps, Theme>) {
  const defaultProps = {
    clickable: true,
    arrowColor: theme.colors.backgroundSecondary,
    effect: 'solid',
    delayHide: 150,
  } as TooltipProps

  return <ReactTooltip {...defaultProps} {...props} />
}

export default withTheme(Tooltip)
